// number of milli seconds in a single hour.
export const MILLI_SEC_IN_A_MINUTE = 60 * 1000

// number of milli seconds in a single hour.
export const MILLI_SEC_IN_A_HOUR = 3600 * 1000

// number of milli seconds in a day of 24hrs.
export const MILLI_SEC_IN_A_DAY = 24 * MILLI_SEC_IN_A_HOUR
export const getCookie = (name) => {
    if (document.cookie) {
        const nameEQ = name + '='
        const ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) == ' ') c = c.substring(1, c.length)
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
        }
    }
    return ''
}

export const setCookie = ({
    name,
    value,
    expiryInDay,
    expiryInHours,
    expiryInMinutes,
    path = '/'
}) => {
    let expires
    const date = new Date()
    if (expiryInDay) {
        date.setTime(date.getTime() + expiryInDay * MILLI_SEC_IN_A_DAY)
        expires = date.toUTCString()
    } else if (expiryInHours) {
        date.setTime(date.getTime() + expiryInHours * MILLI_SEC_IN_A_HOUR)
        expires = date.toUTCString()
    } else if (expiryInMinutes) {
        date.setTime(date.getTime() + expiryInMinutes * MILLI_SEC_IN_A_MINUTE)
        expires = date.toUTCString()
    } else {
        expires = ''
    }

    document.cookie = `${name}=${value}; expires=${expires}; path=${path}`

    return ''
}
export const deleteCookie = (name) => {
    setCookie({ name: name, value: '', expiryInDay: -1 })
}

export const clearAllCookies = () =>{
    // Get all cookies
    const cookies = document.cookie.split(';');
  
    // Loop through each cookie
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
  
      // Delete the cookie by setting its expiration to a past date
      document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
 }